var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{attrs:{"autocomplete":"off"}},[_c('transplant-details-section',{ref:"transplantDetailsSection",attrs:{"new-journey":_vm.newJourney},on:{"handleErrors":_vm.handleErrors,"clear":_vm.clear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }